export const DEFAULT_POPULAR_PAGES_RADIO_FILTER = "isAll";
export const radioItems = [
    {
        value: "isAll",
        label: "filters.title.all",
        tooltip: "filters.title.all.tooltip",
        tracking: "All",
    },
    {
        value: "isNew",
        label: "filters.title.new",
        tooltip: "filters.title.new.tooltip",
        tracking: "New",
    },
    {
        value: "isTrending",
        label: "filters.title.trending",
        tooltip: "filters.title.trending.tooltip",
        tracking: "Trending",
    },
    {
        value: "isEvergreen",
        label: "filters.title.evergreen",
        tooltip: "filters.title.evergreen.tooltip",
        tracking: "Best performing",
    },
];
